import { useFormikContext } from 'formik';
import {Dispatch, SetStateAction, useEffect} from "react";

type FormikPersistType = {
    name: string,
    setSelectedOptionRecipientType?: Dispatch<SetStateAction<string>>
    setPaymentRegion?: Dispatch<SetStateAction<string>>
}

export const FormikPersist = (props: FormikPersistType) => {
    const { values, touched, setValues, setTouched, resetForm } = useFormikContext();

    useEffect(() => {
        const savedData = sessionStorage.getItem(props.name);

        if (savedData) {
            const { values: savedValues, touched: savedTouched }:  any = JSON.parse(savedData);

            if (props.setSelectedOptionRecipientType) {
                props.setSelectedOptionRecipientType(savedValues.recipientType)
            }

            if (props.setPaymentRegion) {
                props.setPaymentRegion(savedValues.paymentRegions)
            }
            setValues(savedValues);
            setTouched(savedTouched); // Восстанавливаем touched
        }
    }, [props.name, setValues, setTouched]);

    useEffect(() => {
        sessionStorage.setItem(props.name, JSON.stringify({ values, touched })); // Сохраняем и values, и touched
    }, [props.name, values, touched]);

    return null;
};
